import React from "react"
import { MDXProvider } from "@mdx-js/react"
import mdxComponents from "./src/components/mdxComponents"
import PageTransitionWrapper from "./src/components/pageTransitionWrapper"

import "./src/styles/index.css"

// Import Animate on Scroll
import AOS from 'aos';



// Initialise Animate on Scroll

AOS.init({
  duration: 700,
  offset: 150,
  throttleDelay: 9,
});

export const wrapRootElement = ({ element }) => (
  <MDXProvider components={mdxComponents}>{element}</MDXProvider>
);

export const wrapPageElement = ({ element, props }) => (
  <PageTransitionWrapper element={element} location={props.location} />
);